var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-cta"},[_c('img',{staticClass:"app-icon",attrs:{"alt":"Wotive app icon","src":require("../../assets/wotive-icon.svg")}}),_c('h2',[_vm._v("Wotive")]),_c('p',[_vm._v("Free Social Gym Tracker")]),_c('div',{staticClass:"download-icons"},[_c('AppleButton'),_c('GoogleButton')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }